import { render, staticRenderFns } from "./EnkelGerecht.vue?vue&type=template&id=cb0cd3ba&scoped=true&"
import script from "./EnkelGerecht.vue?vue&type=script&lang=js&"
export * from "./EnkelGerecht.vue?vue&type=script&lang=js&"
import style0 from "./EnkelGerecht.vue?vue&type=style&index=0&id=cb0cd3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0cd3ba",
  null
  
)

export default component.exports